module.exports = __webpack_public_path__ + "assets/img/38@3x.702a6029.png";